import { AssertionDescriptorUsageTypesEnum } from '../../utilities/Constants';
import { Loader } from '../../components/shared/Loader';
import { PackageSettlementDetailExport } from '../report/PackageSettlementDetailExport';
import { useAuthContext } from '../../contexts/AuthContext';
import { useParams } from 'react-router-dom';
import { useZoneContext } from '../../contexts/useZoneContext';
import { useZoneGetAssertionDescriptors } from '../../shared/react-query-hooks/useZoneGetAssertionDescriptors';

function PackageSettlementDetailExportWrapper() {
    const { guid } = useParams();
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    const assertionDescriptorLookup = useZoneGetAssertionDescriptors(
        AssertionDescriptorUsageTypesEnum.Strategy
    );

    if (assertionDescriptorLookup.isLoading) {
        return <Loader />;
    }

    return (
        <PackageSettlementDetailExport
            assertionDescriptors={assertionDescriptorLookup.data ?? []}
            guid={guid || ''}
            user={user}
            zoneContext={zoneContext}
        />
    );
}

export default PackageSettlementDetailExportWrapper;
